import * as actionType from '../constants/constant.action'

const defaultState = {}

const memberSearchReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_MEMBER_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
      }

    case actionType.GET_MEMBER_SEARCH_SUCCESS:
      if (
        action.payload.response &&
        action.payload.response.status &&
        action.payload.response.status === 500
      ) {
        return {
          loading: false,
          serverError: true,
        }
      }
      return {
        ...action.payload,
        loading: false,
      }

    case actionType.GET_MEMBER_SEARCH_FAILURE:
      return {
        loading: false,
      }

    case actionType.MEMBER_SEARCH_EMPTY:
      return {}

    default:
      return state
  }
}

export default memberSearchReducer
